import { icon, node } from "~/util/dom";
import { createCommercialCollaboration } from "~/ui/commercialCollaboration";

interface ICreateBookingLink {
	link: string;
	title: string;
	logo?: boolean;
	onClick?: () => void;
}

export function createBookingLink({
	link,
	title,
	logo = true,
	onClick = null,
}: ICreateBookingLink) {
	const elem = node("div", { className: "bookingLink" });
	const linkElem = node("a", { href: link, target: "_blank", className: "bookingLink__link", textContent: title, rel: "nofollow" });

	if (onClick) {
		linkElem.addEventListener("pointerdown", () => {
			onClick();
		});
	}

	elem.append(linkElem);

	if (logo) {
		const bookingLine = node("div", { className: "bookingLink__bookingLine" });

		bookingLine.append(createCommercialCollaboration(), icon("booking-logo"));
		elem.append(linkElem, bookingLine);
	}

	return elem;
}
